<template>
  <div class="download_ios">
    <van-image class="image-wrap" v-if="isWeiXin && isAndroid" :src='require("@/assets/images/jumpMask.jpg")'/>
    <van-button type="default" size="small" v-if="isWeiXin && !isIOS" class="btn-copy"
                v-clipboard:error="onError"
                v-clipboard:copy="copyDownloadUrl" v-clipboard:success="onCopy"
    >不能直接下载，试试复制链接去浏览器中粘贴下载</van-button>
<!--    <div class="mask" v-if="isWeiXin && isAndroid">-->
<!--      <div class="tips">1、点击右上角图标</div>-->
<!--      <div class="tips">2、选择 在浏览器中 打开</div>-->
<!--    </div>-->
    <div class="button-wrap">
      <van-image :src='require("@/assets/images/pdf.svg")' style="height: 10em;margin-bottom: 3em"/>

      <van-button type="info" round
                  @click="downloadPdfForByte"
                  :disabled="!isCanDownload"
                  :loading="isLoading"
                  loading-text="正在下载中..."
      >
        <van-image :src='require("@/assets/images/download.svg")' width="4rem" height="4rem" style="vertical-align: middle;color:#ffffff"></van-image>
        点击下载PDF文件</van-button>
      <div class="van-hairline--top" style="margin: 10px;"></div>
      <van-button type="default" round v-if="isWeiXin"
                  v-clipboard:error="onError"
                  v-clipboard:copy="copyDownloadUrl" v-clipboard:success="onCopy"
      >不能直接下载，试试复制链接去浏览器中粘贴下载</van-button>
<!--      <div style="font-size:2em;color: gray;margin-top: 2em">温馨提示：苹果手机请使用Safari-->
<!--        <van-image :src='require("@/assets/images/safari.svg")' style="width: 3em;display: inline-block;vertical-align: middle"/>-->
<!--        浏览器</div>-->
    </div>
  </div>
</template>

<script>
import {Toast} from "vant";
import {encrypt} from "@/assets/utils/cryptoUtil";
import {md5Sign} from "@/assets/utils/sign";

export default {
  data () {
      return {
        isWeiXin:true,
        isIOS: true,
        isAndroid:false,
        downloadUrl:"",
        copyDownloadUrl:"",
        isCanDownload:true,
        pdfDownloadUrl:window.g.VUE_APP_URL + '/getReportPdfByte',
        isLoading:false
      }
  },
  created () {
    this.getIsWxClient();
  },
  mounted() {
    let u = navigator.userAgent;
    this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;  //安卓终端
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);        //苹果终端
    let patientId = this.$route.query.patientId
    let serialNo = this.$route.query.serialNo

    // this.downloadUrl = 'data:application/pdf;base64,' + base64Str
    console.log("isWeiXin:" + this.isWeiXin)
    console.log("isAndroid:" +this.isAndroid)
    console.log("isIOS:" + this.isIOS)
    this.copyDownloadUrl = window.location.href
    // if(!this.isWeiXin){
    //   let param = {
    //     patientid:patientId,
    //     serialno: serialNo
    //   }
    //   getReportBase64Strs(param).then(res => {
    //     if (res.code == 200) {
    //       let base64Str = res.data
    //       if(base64Str!=""){
    //         this.downloadUrl = 'data:application/pdf;base64,' + base64Str
    //         this.isCanDownload = true
    //       }
    //       else{
    //         this.isCanDownload = false
    //         Dialog.alert({
    //           title: '温馨提示',
    //           message: '此份报告还未生成，请留意手机短信或咨询体检中心',
    //         }).then(() => {
    //         });
    //       }
    //     }
    //   })
    // }
  },
  methods: {
    forceHttp() {
      console.log("强制使用HTTP")
      window.location.href = window.location.href.replace('https://', 'http://');
    },
    useHttps() {
      window.location.reload();
    },
    downloadPdf(){
      // 用fetch发送请求 对请求回来的二进制文件流进行处理
      fetch(this.downloadUrl).then((res) => {
        res.blob().then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          // 这里的文件名根据实际情况从响应头或者url里获取
          const filename = this.$route.query.serialNo + '.pdf';
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      });
    },
    downloadPdfForByte() {
      this.isLoading = true;
      // 修改后（增加encodeURIComponent）
      let serialNo = encodeURIComponent(this.$route.query.serialNo); // 对特殊字符编码
      const url = this.pdfDownloadUrl + '?serialno=' + serialNo;
      let time_stamp = new Date().getTime();
      let  sortSignStr = 'serialno=' + this.$route.query.serialNo;
      let md5Str = sortSignStr + '&' + time_stamp;
      let sign = md5Sign(md5Str);
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'sign':sign,
          'timestamp':time_stamp
        },
        body: sortSignStr
      })
          .then(response => {
            if (!response.ok) {
              throw new Error('网络响应错误');
            }
            return response.blob();
          })
          .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const filename = `${this.$route.query.serialNo}.pdf`;
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(blobUrl);
          })
          .catch(error => {
            console.error('下载失败:', error);
            Toast.fail('下载失败');
          })
          .finally(() => {
            Toast('下载完成');
            this.isLoading = false;
          });
    },
    // 复制成功
    onCopy() {
      Toast.success('复制成功');
    },
    // 复制失败
    onError(e) {
      console.log(e)
      Toast.success('复制失败');
    },
    getIsWxClient () {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.isWeiXin = true;
      } else {
        this.isWeiXin = false;
      }
    },
    downloadFile(url, fileName) {
      let xmlHttp = null;
      // IE7+, Firefox, Chrome, Opera, Safari 浏览器执行代码
      xmlHttp = new XMLHttpRequest();

      // 如果实例化成功，就调用open（）方法：
      if (xmlHttp !== null) {
        xmlHttp.open('get', url, true);
        xmlHttp.send();
        xmlHttp.onreadystatechange = readyToDownload;
      } else {
        alert('当前浏览器不支持该操作');
      }

      // 准备下载
      function readyToDownload() {
        /**
         * xmlHttp.readyState:
         * 0 － （未初始化）还没有调用send()方法
         * 1 － （载入）已调用send()方法，正在发送请求
         * 2 － （载入完成）send()方法执行完成，已经接收到全部响应内容
         * 3 － （交互）正在解析响应内容
         * 4 － （完成）响应内容解析完成，可以在客户端调用了
         * */
        if (xmlHttp.readyState !== 4) {
          // 回调函数在每个状态都会被调用一次，因此在准备好之前，直接return，不处理就行
          return;
        }
        if (xmlHttp.status !== 200) {
          return alert('下载失败');
        }

        // 创建隐藏的可下载链接
        var aLink = document.createElement('a');
        aLink.download = fileName; //设置a标签的下载名字
        aLink.style.display = 'none';

        // 字符内容转变成blob地址
        var blob = new Blob([xmlHttp.responseText]);
        aLink.href = URL.createObjectURL(blob);

        // 触发点击
        document.body.appendChild(aLink);
        aLink.click();

        // 移除a标签
        document.body.removeChild(aLink);
      }
    }
  }
}
</script>

<style scoped>
    .mask {
      width: 100%;
      height: 100vh;
      background-color: #666666;
      padding-top: 30%;
    }
    .mask .tips {
      color: #ffffff;
      text-align: center;
      margin-bottom: 20px;
      font-size: 3rem;
    }
    .image-wrap{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottm: 0;
      z-index: 99;
    }
    .button-wrap {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      position: fixed;
      z-index: 9;
      left: 0;
      top: 0;
      right: 0;
      background-color: #fff;
    }
    .button-wrap .btn-download{
      padding: .1em;
      font-weight: bold;
      /*background-color: #1678dc;*/
      /*border: 1px blue solid;*/
      color: #1678dc;
      border-radius: 3em;
      width: 60%;
      height: 3em;
      line-height: 3em;
      font-size: 3em;
      margin-top: 10em;
      text-align: center;
    }
    .download_ios{
      height: 100%;
    }
    .btn-copy{
      position: fixed;
      z-index: 99;
      margin: auto;
      align-items: center;
      display: flex;
      color: red;
      align-content: center;
      justify-content: center;
      left: 10px;
      top: 30px;
      text-decoration: underline;
      font-weight: bold;
    }
</style>
